import React, { memo, useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import { Alert } from 'react-bootstrap';
import { useSelector } from 'react-redux';

import './_notify.scss';

import { getNavbarConfigSelector } from '../../../redux/selectors/header';
import { useWindowSize } from '../../../utils/hooks/useWindowSize';

const Notify = () => {
  const nodeRef = useRef(null);
  const wrapperAlerts = typeof document !== 'undefined'
    ? document.getElementById('wrapper-alerts')
    : null;

  const { notify } = useSelector((state) => getNavbarConfigSelector(state));
  const showNotify = notify?.routes?.some((item) => window.location.pathname.includes(item));

  const [height, setHeight] = useState(0);

  const { width } = useWindowSize();

  useEffect(() => {
    if (nodeRef?.current) {
      setHeight(nodeRef.current.offsetHeight);
    }
  }, [width]);

  if (!showNotify) {
    return null;
  }

  return (
    <span ref={nodeRef}>
      {notify && (
        <Alert
          bsStyle="warning"
          className="alert-fixed fixed-alerts__notify text-center"
        >
          {notify?.message}
        </Alert>
      )}
      {wrapperAlerts && ReactDOM.createPortal(
        <div style={{ height }} />,
        wrapperAlerts,
      )}
    </span>
  );
};

export default memo(Notify);
